import React, { ReactNode } from "react"
import { AppLink } from "@ecom/ui/components/AppLink"

export type Step = {
  title: ReactNode
}

export const STEPS = [
  {
    title: (
      <>
        <span>Оставьте заявку.</span> Онлайн за&nbsp;несколько&nbsp;минут
      </>
    ),
  },
  {
    title: (
      <>
        <span>Получите карту.</span> Доставкой или&nbsp;в&nbsp;отделении банка
      </>
    ),
  },
  {
    title: (
      <>
        <span>Активируйте карту.</span> Совершив <br className="d-sm-none d-md-block" />
        покупку в&nbsp;партнерском магазине
      </>
    ),
  },
]

export const STEPS_GETHALVA = [
  {
    title: (
      <>
        <span>Оставьте заявку.</span> <br className="d-md-none" />В ближайшее время вам поступит
        звонок от&nbsp;банка
      </>
    ),
  },
  {
    title: (
      <>
        <span>Получите карту.</span> <br className="d-ld-none" />
        Доставкой или <br className="d-none d-ld-block" />в отделении банка
      </>
    ),
  },
  {
    title: (
      <>
        <span>Активируйте карту.</span> <br className="d-md-none" />
        Совершив покупку <br className="d-md-none" />
        в&nbsp;партнерском магазине
      </>
    ),
  },
]

export const STEPS_ZAIMY = [
  {
    title: (
      <>
        <span>Оставьте заявку.</span> Онлайн за&nbsp;несколько&nbsp;минут
      </>
    ),
  },
  {
    title: (
      <>
        <span>Получите карту.</span> Доставкой или&nbsp;в&nbsp;отделении банка
      </>
    ),
  },
  {
    title: (
      <>
        <span>Активируйте займ.</span> Совершив покупку в&nbsp;партнерском магазине
      </>
    ),
  },
]

export const STEPS_NA_VYSOTE_CHUVSTV = [
  {
    title: (
      <>
        <span>Активируйте акцию</span> в&nbsp;мобильном приложении или&nbsp;на&nbsp;
        <AppLink
          href="https://halvacard.ru/actions/all/podarki-lyubimym"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "inherit", textDecoration: "underline" }}
        >
          странице акции
        </AppLink>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Совершайте покупки</span> от&nbsp;3&nbsp;000&nbsp;₽ в&nbsp;любых магазинах-партнёрах
        и&nbsp;
        <AppLink
          href="https://fortune.halva.games/actions/na_vysote_chuvstv"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "inherit", textDecoration: "underline" }}
        >
          регистрируйте чеки
        </AppLink>{" "}
        от&nbsp;этих покупок
      </>
    ),
  },
  {
    title: (
      <>
        <span>
          Крутите{" "}
          <AppLink
            href="https://fortune.halva.games/actions/na_vysote_chuvstv"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "inherit", textDecoration: "underline" }}
          >
            Колесо <br className="d-none d-sm-block d-md-none" />
            фортуны
          </AppLink>
        </span>{" "}
        и&nbsp;получайте рассрочку* <br className="d-sm-none" />
        до&nbsp;36 месяцев и&nbsp;кешбэк до&nbsp;70%. А&nbsp;также участвуйте в&nbsp;розыгрыше
        призов
      </>
    ),
  },
]

export const STEPS_PLAIT = [
  {
    title: (
      <>
        <span>Оставь заявку&nbsp;—</span> проверка <br className="d-none d-desk-only-block" />
        займет <br className="d-none d-ld-block" />
        не&nbsp;более 5&nbsp;минут
      </>
    ),
  },
  {
    title: (
      <>
        <span>
          Выбери дату получения
          <br className="d-none d-desk-only-block" /> и&nbsp;способ&nbsp;
        </span>{" "}
        — доставка или&nbsp;самовывоз
      </>
    ),
  },
  {
    title: (
      <>
        <span>Получи карту</span> и&nbsp;активируй <br />
        ее&nbsp;в&nbsp;приложении
      </>
    ),
  },
]

export const STEPS_CASHBACK = [
  {
    title: (
      <>
        Оформите карту Халва. Активируйте** акцию в&nbsp;личном кабинете на&nbsp;
        <AppLink href="https://halvacard.ru/" target="_blank" rel="noreferrer">
          halvacard.ru
        </AppLink>{" "}
        или&nbsp;мобильном приложении
        <br /> «Халва-Совкомбанк»
      </>
    ),
  },
  {
    title: (
      <>
        Совершайте покупки в&nbsp;определённых категориях у&nbsp;
        <AppLink
          href="https://halvacard.ru/shops/actions/zharkij-keshbek/partners"
          target="_blank"
          rel="noreferrer"
        >
          партнёров
        </AppLink>
      </>
    ),
  },
  {
    title: (
      <>
        Становитесь участником розыгрыша кэшбэка
        <br className="d-none d-mob-only-block" /> до&nbsp;100% от&nbsp;суммы покупок
        в&nbsp;период&nbsp;акции
      </>
    ),
  },
]

export const STEPS_CREDIT_CARD_MEDIA = [
  {
    title: (
      <>
        <span>Заполните онлайн-заявку.</span> Это займет всего несколько минут
      </>
    ),
  },
  {
    title: (
      <>
        <span>Узнайте решение.</span> Быстрое <br className="d-none d-md-block" />
        одобрение
      </>
    ),
  },
  {
    title: (
      <>
        <span>Получите карту</span> в&nbsp;удобном <br className="d-none d-md-block" />
        для&nbsp;вас отделении банка
      </>
    ),
  },
]

export const STEPS_PLANETACARD = [
  {
    title: (
      <>
        Получите карту. <span>В&nbsp;течение первого месяца рассрочка*</span>{" "}
        <br className="d-sm-none" />у всех партнеров – <span>24 месяца</span>
      </>
    ),
  },
  {
    title: (
      <>
        Оплачивайте Халвой{" "}
        <span>
          ежемесячно <br className="d-none d-large-block" />
          от&nbsp;5 покупок
        </span>{" "}
        на&nbsp;общую&nbsp;сумму <span>от&nbsp;10&nbsp;000&nbsp;₽</span>
      </>
    ),
  },
  {
    title: (
      <>
        Не платите проценты
        <br />
        <span>24 месяца</span>
      </>
    ),
  },
]

export const STEPS_DOBROE_COFFEE = [
  {
    title: (
      <>
        <span>Ваша карта — старт.</span> <br />
        Оформив ее, вы запустите новый источник помощи
      </>
    ),
  },
  {
    title: (
      <>
        <span>Совкомбанк — помощник в добрых делах.</span>
        <br />
        Выделяет деньги на покупку кофейных автоматов
      </>
    ),
  },
  {
    title: (
      <>
        <span>Аппарат — постоянная помощь.</span>
        <br />
        Регулярно приносит средства для семей героев и спортсменов
      </>
    ),
  },
]

export const STEPS_INVITEFRIEND = [
  {
    title: (
      <>
        <span>Оформите&nbsp;карту&nbsp;«Халва»</span>
        <br />
        Онлайн или в офисе банка
      </>
    ),
  },
  {
    title: (
      <>
        <span>
          Сделайте покупки от&nbsp;1&nbsp;000&nbsp;₽ <br className="d-none d-md-block" />
          в&nbsp;магазинах-партнёрах
        </span>
        <br />
        Начислим 1 000 баллов на&nbsp;ваш&nbsp;счёт
      </>
    ),
  },
  {
    title: (
      <>
        <span>Обменяйте баллы на&nbsp;рубли</span>
        <br />В приложении «Халва-Совкомбанк»
      </>
    ),
  },
]

export const STEPS_SAMOLETIK = [
  {
    title: (
      <>
        <span>Активируйте акцию</span> в мобильном приложении или&nbsp;на&nbsp;
        <AppLink
          href="https://halvacard.ru/actions/all/bumazhnyj-samoletik"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          странице акции
        </AppLink>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Совершайте покупки</span> <br className="d-md-none" />
        в&nbsp;категориях, участвующих в&nbsp;акции
      </>
    ),
  },
  {
    title: (
      <>
        <span>Получите рассрочку</span> <br className="d-ld-none" />
        на&nbsp;12&nbsp;месяцев на&nbsp;эти&nbsp;покупки
      </>
    ),
  },
]

export const STEPS_CASHBACK_100 = [
  {
    title: (
      <>
        <span>Активируйте акцию</span> <br className="d-sm-none d-md-block d-ld-none" />в мобильном
        приложении <br className="d-sm-none d-md-block d-ld-none" />
        или&nbsp;на&nbsp;
        <AppLink
          href="https://halvacard.ru/actions/all/keshbek-do-100-ko-dnyu-semi"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          странице акции
        </AppLink>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Совершайте покупки</span> <br className="d-ld-none" />
        в&nbsp;магазинах партнеров акции
      </>
    ),
  },
  {
    title: (
      <>
        <span>Участвуйте в&nbsp;розыгрыше</span> <br className="d-sm-none d-md-block d-ld-none" />
        кешбэка до&nbsp;100%. Подробные условия&nbsp;
        <AppLink
          href="https://halvacard.ru/actions/all/keshbek-do-100-ko-dnyu-semi"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          по&nbsp;ссылке
        </AppLink>
      </>
    ),
  },
]

export const STEPS_BLACK_FRIDAY_HALVA = [
  {
    title: (
      <>
        <span>Активируйте акцию</span> <br className="d-sm-none d-md-block d-ld-none" />в мобильном
        приложении <br className="d-sm-none d-md-block d-ld-none" />
        или&nbsp;на&nbsp;
        <AppLink
          href="https://halvacard.ru/actions/all/chyornaya-pyatnica-s-keshbekom-i-rassrochkoj"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          странице акции
        </AppLink>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Совершайте покупки</span> в любых магазинах партнёров и{" "}
        <AppLink href="https://hva.im/SA1NSx" rel="nofollow noopener noreferrer" target="_blank">
          регистрируйте чеки
        </AppLink>{" "}
        от этих покупок
      </>
    ),
  },
  {
    title: (
      <>
        <span>Крутите Колесо фортуны</span> и&nbsp;получайте кешбэк до&nbsp;70% и&nbsp;рассрочку
        до&nbsp;18&nbsp;месяцев&sup2;
      </>
    ),
  },
]

export const STEPS_ZHKH = [
  {
    title: (
      <>
        <span>Оформите карту «Халва»</span>
        <br />
        Онлайн за несколько минут
      </>
    ),
  },
  {
    title: (
      <>
        <span>Заберите промокоды</span>
        <br />В приложении или SMS на&nbsp;ваш номер в&nbsp;течение 10&nbsp;дней после оформления
        карты
      </>
    ),
  },
  {
    title: (
      <>
        <span>
          Совершите оплату <br className="d-ld-none" />и примените промокод
        </span>
        <br />
        На ЖКХ или на&nbsp;покупки в&nbsp;супермаркете
      </>
    ),
  },
]

export const STEPS_CASHBACK_FACTORY = [
  {
    title: (
      <>
        <span>Активируйте акцию</span> в мобильном приложении или&nbsp;на&nbsp;
        <AppLink
          href="https://halvacard.ru/actions/all/cashback-factory"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          странице акции
        </AppLink>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Совершайте покупки</span> <br className="d-sm-none" />в магазинах-партнёрах акции
        и&nbsp;регистрируйте чеки от&nbsp;этих покупок
      </>
    ),
  },
  {
    title: (
      <>
        <span>Получите промокод</span> на&nbsp;кешбэк до&nbsp;30% за&nbsp;каждый чек (но не более
        1000 баллов). Подробные условия по&nbsp;
        <AppLink
          href="https://halvacard.ru/actions/all/cashback-factory"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          ссылке
        </AppLink>
      </>
    ),
  },
]

export const STEPS_NOVYI_GOD: Step[] = [
  {
    title: (
      <>
        <span>Активируйте акцию</span> <br className="d-md-none" />
        в&nbsp;мобильном приложении или&nbsp;
        <AppLink
          href="https://halvacard.ru/actions/all/novyj-god-2026"
          target="_blank"
          rel="noreferrer"
        >
          на&nbsp;странице акции
        </AppLink>
      </>
    ),
  },
  {
    title: (
      <>
        <span>Совершайте покупки</span> в&nbsp;магазинах партнёров и&nbsp;
        <AppLink href="https://halvapoly.halva.games/" target="_blank" rel="noreferrer">
          регистрируйте чеки
        </AppLink>{" "}
        на&nbsp;сумму от&nbsp;5&nbsp;000&nbsp;₽
      </>
    ),
  },
  {
    title: (
      <>
        <span>
          <AppLink href="https://halvapoly.halva.games/" target="_blank" rel="noreferrer">
            Играйте в новогоднюю игру
          </AppLink>
        </span>{" "}
        и&nbsp;получайте кэшбэк до&nbsp;5&nbsp;000&nbsp;₽ и&nbsp;до&nbsp;36&nbsp;месяцев рассрочки*,
        а&nbsp;также зарабатывайте билеты на&nbsp;финальный розыгрыш
      </>
    ),
  },
]

export const STEPS_NOVYI_GOD_MEDIA: Step[] = [
  {
    title: (
      <>
        <span>Активируйте акцию</span> <br className="d-md-none" />
        в&nbsp;мобильном приложении или&nbsp;на&nbsp;странице акции
      </>
    ),
  },
  {
    title: (
      <>
        <span>Совершайте покупки</span> <br />
        и&nbsp;регистрируйте чеки от&nbsp;5000&nbsp;рублей
      </>
    ),
  },
  {
    title: (
      <>
        <span>Играйте в новогоднюю игру</span> и&nbsp;получайте до&nbsp;36&nbsp;мес. рассрочки*
        и&nbsp;до&nbsp;5000&nbsp;₽ кэшбэка, а&nbsp;также скидки от&nbsp;партнеров
      </>
    ),
  },
]

export const STEPS_HALVA_VKLAD_MEDIA = [
  {
    title: (
      <>
        <span>Оформите&nbsp;карту&nbsp;«Халва» на&nbsp;сайте</span>
        <br />
        Онлайн за несколько минут
      </>
    ),
  },
  {
    title: (
      <>
        <span>Получите карту</span>
        <br />
        Доставкой&nbsp;или в&nbsp;отделении банка
      </>
    ),
  },
  {
    title: (
      <>
        <span>Откройте вклад, активно пользуйтесь картой «Халва»</span> и&nbsp;получайте до
        +5%&nbsp;годовых к&nbsp;ставке по&nbsp;вкладу
      </>
    ),
  },
]
